import { Platform, Linking as RNLinking } from 'react-native';

import { AuthScreenContainer } from '../components/AuthScreenContainer';
import { Button } from '../components/Button';
import { Text } from '../components/Text';
import { View } from '../components/View';
import { manifest } from '../constants';

export function AppError(props: { retry: () => unknown; type?: 'loading' | 'runtime' }) {
  return (
    <AuthScreenContainer heading="Something went wrong">
      <View spacing={40} style={{ padding: Platform.OS === 'web' ? 20 : 0 }}>
        {props.type === 'runtime' ? (
          <Text
            text={`We're sorry, but something went wrong. Please try reloading ${manifest.name}.`}
          />
        ) : (
          <Text
            text={`We're sorry, but we couldn't load ${manifest.name}. Please make sure you're connected to the internet.`}
          />
        )}
        <View>
          <Text text="If you're in crisis, please call the National Suicide Prevention Lifeline." />
          <Button
            text="Call Lifeline"
            onPress={() => RNLinking.openURL('tel:988')}
            alignSelf="flex-start"
            variant="text"
            testID="AppError_callLifelineButton"
          />
        </View>
        <Button
          text={`Reload ${manifest.name}`}
          onPress={() => props.retry()}
          testID="AppError_reloadButton"
        />
      </View>
    </AuthScreenContainer>
  );
}
